/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.State = exports.SortOrder = exports.SiteCreatedContext = exports.PrivacyStatusStatus = exports.Namespace = exports.DeleteStatus = exports.ActivityStatusStatus = exports.AccessStatusStatus = void 0;
var AccessStatusStatus;
(function (AccessStatusStatus) {
    AccessStatusStatus["UNKNOWN"] = "UNKNOWN";
    AccessStatusStatus["PENDING"] = "PENDING";
    AccessStatusStatus["APPROVED"] = "APPROVED";
    AccessStatusStatus["BLOCKED"] = "BLOCKED";
    AccessStatusStatus["OFFLINE"] = "OFFLINE";
})(AccessStatusStatus = exports.AccessStatusStatus || (exports.AccessStatusStatus = {}));
var ActivityStatusStatus;
(function (ActivityStatusStatus) {
    ActivityStatusStatus["UNKNOWN"] = "UNKNOWN";
    ActivityStatusStatus["ACTIVE"] = "ACTIVE";
    ActivityStatusStatus["MUTED"] = "MUTED";
})(ActivityStatusStatus = exports.ActivityStatusStatus || (exports.ActivityStatusStatus = {}));
var DeleteStatus;
(function (DeleteStatus) {
    DeleteStatus["UNKNOWN"] = "UNKNOWN";
    DeleteStatus["TRASH"] = "TRASH";
    DeleteStatus["DELETED"] = "DELETED";
    DeleteStatus["PENDING_PURGE"] = "PENDING_PURGE";
})(DeleteStatus = exports.DeleteStatus || (exports.DeleteStatus = {}));
var Namespace;
(function (Namespace) {
    Namespace["UNKNOWN_NAMESPACE"] = "UNKNOWN_NAMESPACE";
    Namespace["WIX"] = "WIX";
    Namespace["SHOUT_OUT"] = "SHOUT_OUT";
    Namespace["ALBUMS"] = "ALBUMS";
    Namespace["WIX_STORES_TEST_DRIVE"] = "WIX_STORES_TEST_DRIVE";
    Namespace["HOTELS"] = "HOTELS";
    Namespace["CLUBS"] = "CLUBS";
    Namespace["ONBOARDING_DRAFT"] = "ONBOARDING_DRAFT";
    Namespace["DEV_SITE"] = "DEV_SITE";
    Namespace["LOGOS"] = "LOGOS";
    Namespace["VIDEO_MAKER"] = "VIDEO_MAKER";
    Namespace["PARTNER_DASHBOARD"] = "PARTNER_DASHBOARD";
    Namespace["DEV_CENTER_COMPANY"] = "DEV_CENTER_COMPANY";
    Namespace["HTML_DRAFT"] = "HTML_DRAFT";
    Namespace["SITELESS_BUSINESS"] = "SITELESS_BUSINESS";
    Namespace["CREATOR_ECONOMY"] = "CREATOR_ECONOMY";
    Namespace["DASHBOARD_FIRST"] = "DASHBOARD_FIRST";
    Namespace["ANYWHERE"] = "ANYWHERE";
    Namespace["HEADLESS"] = "HEADLESS";
    Namespace["ACCOUNT_MASTER_CMS"] = "ACCOUNT_MASTER_CMS";
})(Namespace = exports.Namespace || (exports.Namespace = {}));
var PrivacyStatusStatus;
(function (PrivacyStatusStatus) {
    PrivacyStatusStatus["UNKNOWN"] = "UNKNOWN";
    PrivacyStatusStatus["PRIVATE"] = "PRIVATE";
    PrivacyStatusStatus["PUBLIC"] = "PUBLIC";
})(PrivacyStatusStatus = exports.PrivacyStatusStatus || (exports.PrivacyStatusStatus = {}));
var SiteCreatedContext;
(function (SiteCreatedContext) {
    SiteCreatedContext["OTHER"] = "OTHER";
    SiteCreatedContext["FROM_TEMPLATE"] = "FROM_TEMPLATE";
    SiteCreatedContext["DUPLICATE_BY_SITE_TRANSFER"] = "DUPLICATE_BY_SITE_TRANSFER";
    SiteCreatedContext["DUPLICATE"] = "DUPLICATE";
    SiteCreatedContext["OLD_SITE_TRANSFER"] = "OLD_SITE_TRANSFER";
    SiteCreatedContext["FLASH"] = "FLASH";
})(SiteCreatedContext = exports.SiteCreatedContext || (exports.SiteCreatedContext = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
var State;
(function (State) {
    State["UNKNOWN"] = "UNKNOWN";
    State["ENABLED"] = "ENABLED";
    State["DISABLED"] = "DISABLED";
    State["PENDING"] = "PENDING";
    State["DEMO"] = "DEMO";
})(State = exports.State || (exports.State = {}));
//# sourceMappingURL=types.js.map